export default class BuyerRegistrationService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    utils,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.$q = $q;
    this.utils = utils;
    this.ngAuthSettings = ngAuthSettings;
  }

  createBRP(accountId, brp, setAsDefault) {
    const url = this.#serviceBaseUrl(accountId);
    const newBRP = this.#initBRPCreateRequest(brp, setAsDefault);

    return this.$http.post(url, newBRP).then(this.utils.rejectPromiseOnAPIError);
  }

  updateBRP(accountId, brp) {
    const url = this.#serviceBaseUrl(accountId, brp.id);
    const newBRP = this.#initBRPPatchRequest(brp);

    return this.$http.patch(url, newBRP).then(this.utils.rejectPromiseOnAPIError);
  }

  getDefaultBRP(accountId) {
    return this.getBRPById(accountId, 'default');
  }

  getBRPById(accountId, brpId) {
    const url = this.#serviceBaseUrl(accountId, brpId);
    return this.$http.get(url).then(this.utils.rejectPromiseOnAPIError);
  }

  getPublicBRPDetails(brpId) {
    const url = this.#servicePublicBaseUrl(brpId);
    return this.$http.get(url);
  }

  submitBRPForm(brpId, formData) {
    const url = this.#servicePublicBaseUrl(brpId);
    return this.$http.post(url, formData).then(this.utils.rejectPromiseOnAPIError);
  }

  #servicePublicBaseUrl(brpId) {
    return this.ngAuthSettings.apiServiceBaseUri + 'BuyerSignup/' + brpId;
  }

  #serviceBaseUrl(accountId, brpId) {
    let result = this.ngAuthSettings.apiServiceBaseUri + accountId + '/buyer-registration';

    if (brpId) {
      result += '/' + brpId;
    }

    return result;
  }

  #initBRPPatchRequest(brp) {
    const result = {
      name: brp.name || '',
      enabled: !!brp.enabled,
      description: brp.description || '',
      contactEmail: brp.contactEmail || '',
      requireAgreementToTerms: !!brp.requireAgreementToTerms,
      customFields: brp.customFields || null,
      termsAndConditions: brp.termsAndConditions,
      isTermsAndConditionsURL: brp.isTermsAndConditionsURL,
    };

    return result;
  }

  #initBRPCreateRequest(brp, setAsDefault) {
    const result = {
      name: brp.name || '',
      enabled: !!brp.enabled,
      description: brp.description || '',
      contactEmail: brp.contactEmail || '',
      requireAgreementToTerms: !!brp.requireAgreementToTerms,
    };

    if (brp.customFields) {
      result.customFields = brp.customFields;
    }

    if (setAsDefault === true) {
      result.setAsDefault = true;
    }

    if (brp.requireAgreementToTerms) {
      result.termsAndConditions = brp.termsAndConditions;
      result.isTermsAndConditionsURL = brp.isTermsAndConditionsURL;
    }

    return result;
  }
}